import { createFileRoute } from '@tanstack/react-router'
import { EditProcedurePage } from '_/features/pets/ui/pages/edit-procedure-page'

const EditProcedureRoute = () => {
	const { petId, procedureId } = Route.useParams()
	return <EditProcedurePage petId={petId} procedureId={procedureId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/procedures/$procedureId/edit')({
	staticData: { title: 'procedures_edit_title' },
	component: EditProcedureRoute,
})
